import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const notificationBubbleStyle = ({
  show,
  borderColor,
  backgroundColor = theme.colors.critical50,
}: {
  show: boolean;
  borderColor?: string;
  backgroundColor?: string;
}) => css`
  ::after {
    background: ${backgroundColor};
    border-radius: 16px;
    border: 1px solid ${borderColor || 'white'};
    content: '';
    height: 10px;
    left: 45px;
    opacity: ${show ? 1 : 0};
    position: absolute;
    top: 6px;
    /* match the animation and color of the icon button hover */
    transition: border-color, opacity ease-in-out 250ms;
    width: 10px;
    z-index: 10;
  }
`;

export const cssVariables = (isFullWidth?: boolean) => [
  css`
    --nav-icon-width: 84px;
    --nav-item-font-size: ${theme.font.size.large};
    --nav-background-color: ${theme.colors.neutral10};
    --nav-slim-closed-width: 36px;
    --nav-slim-width: 120px;
    --nav-width: 100%;
  `,
  isFullWidth
    ? css`
        --nav-width: 100%;
      `
    : css`
        --nav-width: 284px;
      `,
];

export const fullOpenStyle = css`
  width: calc(var(--nav-width) - var(--nav-icon-width));
`;

export const slimOpenStyle = ({ open }: { open: boolean }) =>
  css([
    css`
      width: calc(var(--nav-width) - var(--nav-icon-width));
    `,
    open
      ? css`
          left: var(--nav-icon-width);
        `
      : css`
          left: calc(((var(--nav-icon-width) - 4px) * -1));
        `,
  ]);
